export default __webpack_public_path__ + "static/media/supermarketScreen.e5bed6b8.jpg";